import React from 'react';
import PropTypes from 'prop-types';

const TrustRatings = ( ) => <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection:'column' }}>
    <h2 style={{ fontWeight:500, fontSize:30, marginTop:40, marginBottom:12, textTransform:'unset', fontFamily:'sans-serif' }} >
        Fremragende
    </h2>
    <div className='trust-ratings' style={{ width:270 }}></div>
    <p style={{ marginBottom:100, marginTop:12, fontFamily:'sans-serif' }}>4,8 ud af 5</p>
</div>;

export default TrustRatings;
